import loginReducer from "./loginReducer";
import userSymbolsReducer from "./userSymbolsReducer"
import userLicenseReducer from "./userLicenseReducer"
import userDashboardSettingsReducer from "./userDashboardSettingsReducer"
import dashboardElementsReducer from "./dashboardElementsReducer"
import {configureStore, combineReducers} from "@reduxjs/toolkit";

const rootReducer = combineReducers({
    user: loginReducer,
    userSymbols: userSymbolsReducer,
    userLicense: userLicenseReducer,
    userDashboardSettings: userDashboardSettingsReducer,
    dashboardElements: dashboardElementsReducer
})
export const setupStore = () => {
    return configureStore({
        reducer: rootReducer
    })
}

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>

export type AppDispatch = AppStore['dispatch']